import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import httpRequest from '@/utils/httpRequest'
import '@/utils/rem'
import qs from 'qs'
import cookie from 'vue-cookie'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/css/main.less'
import 'tinymce/skins/ui/oxide/skin.min.css'
import '@/filters/timefilter';
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap,{ak:'AXZcE1aSoCLBOJ0QQBEvFVgctLLwpjai'})


Vue.config.productionTip = false

Vue.prototype.qs = qs
Vue.prototype.$http = httpRequest
Vue.prototype.$cookie = cookie

Vue.use(ElementUI);


function _isMobile(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag; 
}

router.beforeEach((to, from, next) => {
  document.title=to.meta.title
  const identity = cookie.get('token')||''
  let arr=['/scrollImage','/newsAdd','/news','/itemSystem','/BusinessList','/Industry','/talents','/aboutUs','/companyInfo']
  if(!identity&&arr.includes(to.path)){
    next('/administaration')
  }else{
  //  if(_isMobile()&&to.path.indexOf('Mobile')==-1){
  //    //手机端用户，进入的路由不包含‘Mobile’,给其拼接上Mobile
  //    let arr = to.path.split('')
  //   arr.splice(1,0,'Mobile')
  //   let newPath = arr.join('')
  //     console.log('手机端不要进PC网页！',to.path,newPath);
  //     next(newPath)
  //  }else if(!_isMobile()&&to.path.indexOf('Mobile')!=-1){
  //    //如果是电脑端用户进入手机端，则移除路由中的Mobile字段
  //      let arr = to.path.split('')
  //      arr.splice(1,6)
  //      let newPath = arr.join('')
  //      console.log('电脑端不要进手机网页',to,newPath);
  //      next(newPath)
  //  }else{
    next()
  //  }
  }
  
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
